
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
    display: flex
}
.wrapper {
    flex-grow: 1;
    padding: 1.5rem
}
.outline-bg--neutral-white {
    background-color: var(--neutral-white)
}
.outline-bg--primary-blue {
    background-color: var(--primary-blue);
    color: var(--neutral-white)
}
.outline-bg--primary-green {
    background-color: var(--primary-green);
    color: var(--neutral-white)
}
.outline-bg--neutral-gray-5 {
    background-color: var(--neutral-gray-5)
}
.outline-bg--gradient-blue {
    background-image: var(--blue-gradient);
    color: var(--neutral-white)
}
.outline-bg--gradient-green {
    background-image: var(--green-gradient);
    color: var(--neutral-white)
}
.outline-bg--primary-blue ::slotted(ghs-heading), .outline-bg--primary-green ::slotted(ghs-heading), .outline-bg--gradient-blue ::slotted(ghs-heading), .outline-bg--gradient-green ::slotted(ghs-heading) {
    color: var(--neutral-white)
}
:host([site='BH']) .outline-bg--neutral-white {
    background-color: var(--bh-neutral-white)
}
:host([site='BH']) .outline-bg--bh-brand-primary-default, :host([site='BH']) .outline-bg--primary-blue, :host([site='BH']) .outline-bg--primary-green, :host([site='BH']) .outline-bg--neutral-gray-5, :host([site='BH']) .outline-bg--gradient-blue, :host([site='BH']) .outline-bg--gradient-green {
    background-color: var(--bh-brand-primary-default)
}
:host([site='BH']) .outline-bg--bh-brand-primary-default, :host([site='BH']) .outline-bg--primary-blue, :host([site='BH']) .outline-bg--primary-green, :host([site='BH']) .outline-bg--neutral-gray-5, :host([site='BH']) .outline-bg--gradient-blue, :host([site='BH']) .outline-bg--gradient-green {
    color: var(--bh-neutral-white)
}
:host([site='BH']) .outline-bg--primary-blue ::slotted(ghs-heading), :host([site='BH']) .outline-bg--primary-green ::slotted(ghs-heading), :host([site='BH']) .outline-bg--gradient-blue ::slotted(ghs-heading), :host([site='BH']) .outline-bg--gradient-green ::slotted(ghs-heading), :host([site='BH']) .outline-bg--bh-brand-primary-default ::slotted(ghs-heading) {
    color: var(--bh-neutral-white)
}
`;